import { jsx as o } from "@emotion/react/jsx-runtime";
import p from "prop-types";
import { useTheme as s } from "../../theme.mjs";
const i = ({ fill: r, ...t }) => {
  const e = s();
  return /* @__PURE__ */ o(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: r || e.colors.foreground,
      ...t,
      children: /* @__PURE__ */ o("path", { d: "M15 13.75V19H18V12V5H15V10.25L6 5V19L15 13.75Z" })
    }
  );
};
i.propTypes = {
  fill: p.string
};
export {
  i as Next
};
